import { Flex, Avatar, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { DataList } from './data_list.component';
import { withTranslation } from '@application/i18n/with_translation';

interface AvatarInfoProps {
	name?: string;
	title?: string;
	avatarSrc?: string;
	align?: 'left' | 'right';
}

export function AvatarInfo({ name, title, avatarSrc, align = 'left' }: AvatarInfoProps) {
	return (
		<Flex direction={align === 'right' ? 'row-reverse' : 'row'} gap={tokens.spacing.x1}>
			<Avatar name={name ?? ''} src={avatarSrc} />
			<DataList.Root variant='slim' align={align}>
				{name ? (
					<DataList.Item label={withTranslation('Component.AvatarInfo.Label.Name')} hideLabel>
						<Text variant='labelSemiBold' color={tokens.color.content.default}>
							{name}
						</Text>
					</DataList.Item>
				) : null}
				{title ? (
					<DataList.Item label={withTranslation('Component.AvatarInfo.Label.Title')} hideLabel>
						<Text variant='labelSmallRegular' color={tokens.color.content.muted}>
							{title}
						</Text>
					</DataList.Item>
				) : null}
			</DataList.Root>
		</Flex>
	);
}
